<template>
<section class="photo-grid px-4">
    <div class="max-w-5xl mx-auto">
        <div class="grid gap-4" :class="`with-${columns}-columns`">
            <div v-for="(photo, i) in photos" class="rounded-md overflow-hidden flex items-center">
                <SmoothLoader tag="img" :src="photo.src" :alt="photo.alt" :delay="i * 200"></SmoothLoader>
            </div>
        </div>
    </div>
</section>
</template>

<script>
import { computed } from 'vue';
export default {
    
    props: ['data'],

    setup(props) {

        const columns = computed(() => {
            let count = props.data.photos.length;
            if (count % 4 === 0) {
                return 4;
            }
            if (count % 3 === 0) {
                return 3;
            }
            return 2;
        });

        return {
            columns,
            ...props.data
        }
    }

}
</script>